import { useState } from "react";
import type { ProductBgCardComponentModel } from "@services/api";
import { Card, Space, Typography, Row, Col } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { bxOpenSlider } from "@lib/bx24";

const { Text } = Typography;

interface Props {
  data?: ProductBgCardComponentModel;
}

const guaranteeTypeMap: Record<string, string> = {
  participation: "На участие в торгах",
  execution: "На исполнение обязательств по контракту",
  returnAdvance: "На возврат аванса",
  period: "На обеспечение гарантийных обязательств",
};

export default function ProductBgLink({ data }: Props) {
  const { id, guaranteeType } = data || {};
  const label = guaranteeType ? guaranteeTypeMap[guaranteeType] : "";

  const [hovered, setHovered] = useState(false);

  const handleOpen = () => {
    bxOpenSlider("productBg", { productId: id });
  };

  const cardStyle: React.CSSProperties = {
    cursor: "pointer",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    borderColor: hovered ? "#1677ff" : undefined,
    boxShadow: hovered
      ? "0 0 0 2px rgba(22, 119, 255, 0.12), 0 6px 16px -8px rgba(22, 119, 255, 0.2)"
      : undefined,
  };

  return (
    <Card
      size="small"
      bordered
      hoverable
      style={cardStyle}
      onClick={handleOpen}
      role="button"
      tabIndex={0}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleOpen();
        }
      }}
    >
      <Space direction="vertical" size={0}>
        <Row justify="space-between" align="middle" wrap={false}>
          <Col flex="auto">
            <Text strong ellipsis={{ tooltip: label || "" }}>
              {label || "—"}
            </Text>
          </Col>
          <Col>
            <EditOutlined aria-label="Редактировать" />
          </Col>
        </Row>

        <Text type="secondary" style={{ fontSize: 12 }}>
          Тип гарантии
        </Text>
      </Space>
    </Card>
  );
}
